module.exports = __webpack_public_path__ + "assets/img/ic-wel-mission.80701577.png";